/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FCS API
 * Field Compliance System — REST API
 * OpenAPI spec version: 0.0.54-SNAPSHOT
 */
import type {
  StoreDto,
  TeamDto
} from '../model';

import { customInstance } from '../../mutator/custom-instance';



  export const getStores = () => {
/**
 * Returns the list of all currently open Decathlon stores. Store data is synchronized
 * from Master Data and filtered to include only active stores. The store name is
 * returned in the language specified by the Accept-Language header when available.
 * Used for store selection in the application.
 * @summary Get all open stores
 */
const findStores = (

 ) => {
      return customInstance<StoreDto[]>(
      {url: `/api/v1/stores`, method: 'GET'
    },
      );
    }
  /**
 * Returns the list of teams operating within the specified store. Teams represent
 * organizational units responsible for specific product categories or store areas.
 * Team data is synchronized from Master Data. Used for team selection after a
 * store has been chosen.
 * @summary Get teams for a store
 */
const getStoreTeams = (
    storeId: number,
 ) => {
      return customInstance<TeamDto[]>(
      {url: `/api/v1/stores/${storeId}/teams`, method: 'GET'
    },
      );
    }
  return {findStores,getStoreTeams}};
export type FindStoresResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStores>['findStores']>>>
export type GetStoreTeamsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getStores>['getStoreTeams']>>>
